import React, { memo } from "react";
import ReusableAccordian from "../ReusableAccordion";
import { Typography } from "@mui/material";
import Choices from "../Choices";
import { Image } from "cloudinary-react";
import InfoIcon from "@mui/icons-material/Info";
import { RowLayout } from "../../util/accordianStyles";
import usePivotPointSelector from "./usePivotPointSelector";
import PleaseNote from "../PleaseNote";

function PivotPointAccordian() {
  const {
    imgLabel,
    checkMark,
    variant,
    handleClick,
    overall,
    pivotHardware,
    pivots,
    pivotPoint,
  } = usePivotPointSelector();

  return (
    <ReusableAccordian
      accordionName="pivot"
      heading="Pivot Point"
      secondaryHeading="Select pivot point (inches)"
      colOrRow="col"
    >
      {overall && pivotHardware && pivots?.length ? (
        <>
          <RowLayout style={{ paddingBottom: 20 }}>
            <PleaseNote
              notes={[
                "The pivot axis point is the vertical point around which the door",
              ]}
            />
          </RowLayout>

          {/* //remove 4 3/4 pivot axis from fristjurgens because we need enough room for dowels */}
          <RowLayout>
            {pivotHardware === "Fritsjurgens"
              ? pivots
                  .filter((itm) => itm.label !== '4-3/4" Pivot Axis Point')
                  .map((state) => (
                    <div
                      key={state.id}
                      onClick={() => handleClick(state.label)}
                    >
                      <Choices
                        label={state.label}
                        variant={variant(state.label)}
                        checkMark={checkMark(state.label)}
                        wide={true}
                      />
                    </div>
                  ))
              : pivots.map((state) => (
                  <div key={state.id} onClick={() => handleClick(state.label)}>
                    <Choices
                      label={state.label}
                      variant={variant(state.label)}
                      checkMark={checkMark(state.label)}
                      wide={true}
                    />
                  </div>
                ))}
          </RowLayout>
        </>
      ) : (
        <Typography>Enter a Frame Width and Pivot Hardware</Typography>
      )}

      {pivotPoint && (
        <Image
          cloudName="ag-millworks"
          secure="true"
          publicId={`/Pivot_Axis/${imgLabel}`}
        />
      )}
    </ReusableAccordian>
  );
}

export default memo(PivotPointAccordian);
